/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

export const DEFAULT__SIGN_IN_EMAIL_FIELD = [
  {
    customUpperCode: 'email',
    code: 'email',
    default_value: '',
    entity_type: 'CUSTOMER',
    frontend_class: 'auth-sign-in-form__form__email',
    frontend_input: 'TEXT',
    is_required: true,
    multiline_count: 1,
    sort_order: 1,
    is_unique: false,
    label: 'Email',
    options: [],
    validateRules: [
      {
        name: 'INPUT_VALIDATION',
        value: 'email',
      },
    ],
    autocomplete: 'username',
  },
];

export const DEFAULT__RESET_PASSWORD_EMAIL_FIELD: Record<
  string,
  string | boolean | unknown
>[] = [
  {
    customUpperCode: 'email',
    code: 'email',
    default_value: '',
    entity_type: 'CUSTOMER',
    frontend_class: 'auth-reset-password-form__form__item',
    frontend_input: 'TEXT',
    is_required: true,
    is_unique: false,
    label: 'Email',
    options: [],
    validateRules: [
      {
        name: 'INPUT_VALIDATION',
        value: 'email',
      },
    ],
    autocomplete: 'username',
  },
];

export const DEFAULT_SIGN_UP_FIELDS = [
  {
    customUpperCode: 'email',
    code: 'email',
    default_value: '',
    entity_type: 'CUSTOMER',
    frontend_class: '',
    frontend_input: 'TEXT',
    is_required: true,
    is_unique: false,
    label: 'Email',
    multiline_count: 1,
    sort_order: 1,
    options: [],
    validateRules: [
      {
        name: 'INPUT_VALIDATION',
        value: 'email',
      },
    ],
    autocomplete: 'username',
  },
  {
    customUpperCode: 'firstname',
    code: 'firstname',
    default_value: '',
    entity_type: 'CUSTOMER',
    frontend_class: '',
    frontend_input: 'TEXT',
    is_required: true,
    is_unique: false,
    label: 'First name',
    multiline_count: 1,
    sort_order: 2,
    options: [],
  },
  {
    customUpperCode: 'lastname',
    code: 'lastname',
    default_value: '',
    entity_type: 'CUSTOMER',
    frontend_class: '',
    frontend_input: 'TEXT',
    is_required: false,
    is_unique: false,
    label: 'Last name',
    multiline_count: 1,
    sort_order: 3,
    options: [],
  },
];

export const DEFAULT_INPUTS_PROPS: Record<string, string | ''> = {
  dob: '',
  email: '',
  firstname: '',
  gender: '',
  lastname: '',
  middlename: '',
  password: '',
  prefix: '',
  suffix: '',
  taxvat: '',
};
